import React, { useEffect, useMemo, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { fetchNotice } from "../../../_redux/notices/NoticesActions";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
  ModalProgressBar,
} from "../../../../../../_metronic/_partials/controls";
import { AttachmentList } from "../../../../../../_metronic/_partials/attachments/AttachmentList";
import DOMPurify from "dompurify";

export function NoticeSingle({
                               history,
                               match: {
                                 params: { id },
                               },
                             }) {
  const [title, setTitle] = useState("");

  const dispatch = useDispatch();

  const { actionsLoading, noticeToView } = useSelector(
      (state) => ({
        actionsLoading: state.notices.actionsLoading,
        noticeToView: state.notices.noticeToView,
      }),
      shallowEqual
  );

  useEffect(() => {
    if (dispatch && id) dispatch(fetchNotice(id));
  }, [id, dispatch]);

  useEffect(() => {
    if (noticeToView) setTitle(noticeToView.name);
  }, [noticeToView]);

  const sanitizedDescription = useMemo(() => {
    return DOMPurify.sanitize(noticeToView?.description || "");
  }, [noticeToView]);

  return (
      <Card>
        {actionsLoading && <ModalProgressBar />}
        <CardHeader
            title={title}
            dateTime={new Date(noticeToView?.createDate).toLocaleString("fa-IR")}
        >
          <CardHeaderToolbar>
            <button
                type={"button"}
                className={"btn mr-4"}
                style={{ cursor: "default" }}
            >
              <i className={"fa fa-eye"} />
              <span className={"font-size-h3"} style={{ color: "#6b6b6b" }}>
              {noticeToView?.viewCount}
            </span>
            </button>

            <button
                type={"button"}
                onClick={() => history.push(`/operation/notices/${id}/edit`)}
                className={"btn btn-primary mr-4"}
            >
              <i className={"fa fa-edit"} />
              ویرایش
            </button>

            <button
                type={"button"}
                onClick={() => history.push("/operation/notices")}
                className={"btn btn-light"}
            >
              <i className={"fa fa-arrow-left"} />
              برگشت
            </button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <div className={"mb-5"}>
            <div className={"d-flex flex-column mb-8"}>
              <div>
                <p className={"font-size-h6 mb-1 font-weight-bolder"}>
                  توضیحات اطلاعیه:
                </p>
                <div
                    className="ml-4"
                    dangerouslySetInnerHTML={{ __html: sanitizedDescription }}
                />
              </div>
            </div>
          </div>
          <hr />
          <h4 className={"mb-6"}>پیوست ها:</h4>
          {noticeToView && !actionsLoading && (
              <AttachmentList model={"Notice"} recordId={noticeToView.id} />
          )}
        </CardBody>
      </Card>
  );
}
